export enum ResellerStatusEnum {
    Active = 'Active',
    Inactive = 'Inactive',
}